import FloatingPaneAction, { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'
import InsightsActions, { INSIGHT_CTA_CLICK } from 'actions/insightsActions'
import { PushAction, pushActionCreator } from 'actions/navigationActions'
import { byType } from 'rxOperators/byType'
import { EpicRefined } from 'interfaces/middleware'
import { EMPTY, merge, of } from 'rxjs'
import { filter, map, mergeMap, switchMap, take } from 'rxjs/operators'
import { isAuthenticatedSelector } from 'selectors/globalSelectors'


export const meetingCTAEpic: EpicRefined<InsightsActions | FloatingPaneAction | PushAction> = (action$, store) => {
  const auth$ = action$.pipe(
    map(() => isAuthenticatedSelector(store.getState())),
    mergeMap((isAuth) => {
      if (isAuth === null) {
        return EMPTY
      }

      return of(isAuth)
    }),
    take(1),
    filter(Boolean),
  )


  return action$.pipe(
    byType(INSIGHT_CTA_CLICK),
    mergeMap(({ payload }) => {
      if (payload.type !== 'meeting_info') {
        return EMPTY
      }

      return of(payload)
    }),
    switchMap((payload) => auth$.pipe(
      mergeMap((isAuth) => {
        if (!isAuth) {
          return EMPTY
        }

        const { uid } = payload.cta
        return merge(
          of(pushActionCreator('/coaching')),
          of(modifyFloatingPaneActionCreator('advisor', { mode: 'meeting', uid })),
        )
      })
    ))
  )
}
